<template lang="pug">
    fragment
        div.lightning(:style="visibility")
            img(:src="lightningImage" alt="lightning")

        div.lightning.lightning-2(:style="visibility")
            img(:src="lightningImage" alt="lightning")

        div.lightning.lightning-3(:style="visibility")
            img(:src="lightningImage" alt="lightning")

        div.lightning.lightning-4(:style="visibility")
            img(:src="lightningImage" alt="lightning")
</template>

<script>
    import VueTypes from 'vue-types';
    import lightningImage from './lightning.png';

    export default {
        props: {
            mood: VueTypes.number.def(0)
        },
        data() {
            return {
                lightningImage
            };
        },
        computed: {
            /**
             * Visibility
             * @returns {{display: string}}
             */
            visibility() {
                return {
                    display: `${this.mood < 10 ? 'block' : 'none'}`
                };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../assets/style/_variables.styl'

    @keyframes flash
        from
            opacity: 0
        89%
            opacity: 0
        90%
            opacity: 0.6
        94%
            opacity: 0.2
        96%
            opacity: 0.8
        to
            opacity: 0

    .lightning
        z-index: 3
        position: absolute
        top: -30%
        left: -30%
        overflow: hidden
        width: 100%
        height: 100%
        animation: flash 7s ease-in-out infinite
        transform: rotate(-37deg)
        border-radius: 50%
        box-shadow: 0 0 100px rgba(255, 255, 255, 0.1)
        will-change: will

    .lightning-2
        left: auto
        right: -20%
        top: -40%
        animation: flash 4.5s ease-in-out 1.2s infinite
        transform: rotate(90deg)

    .lightning-3
        left: auto
        right: -10%
        top: -75%
        animation: flash 5s ease-in-out 1s infinite
        transform: rotate(60deg)


    .lightning-4
        left: auto
        right: -30%
        top: -45%
        animation: flash 10s ease-in-out 4s infinite;
        transform: rotate(60deg)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .lightning
            top: -10%
            left: -10%

            img
                width: 100%
</style>
